<template>
  <PuilDemandasFormPesquisa />
  <div>
    <q-table
      class="fit"
      :columns="columns.map(column => ({ ...column, align: 'left' }))"
      row-key="id"
      :rows="rows"
      @row-click="(evt, row) => $router.push(`/puil/${row.numero}`)"
      @request="request"
      v-model:pagination="_pagination"
    >
      <template v-slot:body-cell-acoes="puil">
        <q-td :props="puil">
          <q-btn
            flat
            icon="delete_outline"
            title="Excluir Puil"
            @click.stop="deletePuil(puil.row.numero)"
            v-if="admin"
          />
        </q-td>
      </template>
    </q-table>
    <AppConfirmModal v-model="confirmThemeDeletion" question="Tem certeza de que deseja excluir o PUIL?" @ok="excluirPuil(idPuilExcluir)" />
  </div>
</template>


<script setup>
import PuilDemandasFormPesquisa from "@/components/puil-demandas-form-pesquisa.vue";
import AppConfirmModal from "@/components/app/AppConfirmModal.vue"
import { usePuilSituacaoStore } from "@/store/puil-situacao-store";
import { defineProps, defineEmits, ref, computed } from "vue";
import { useUserStore } from "@/store/user-store";
const userStore = useUserStore();
const situacaoStore = usePuilSituacaoStore();
situacaoStore.fetch();

const props = defineProps({
  rows: {},
  pagination: {},
  headers: {
    type: Array,
    default: Array.from([
      "pje",
      "puil",
      "situacao",
      "acoes"
    ])
  }
});


const emit = defineEmits(["del", "update:pagination", "request"]);
const request = v => emit("request", v);
const _pagination = computed({
  get: () => props.pagination,
  set: v => emit("update:pagination", v)
});

const admin = computed(() => userStore.admin);
const nomeSituacaoFromId = id =>
  situacaoStore.all.find(situacao => situacao.id == id)?.descricao;

const confirmThemeDeletion = ref(false);
const idPuilExcluir = ref(0);
const deletePuil = id => {
  idPuilExcluir.value = id;
  confirmThemeDeletion.value = true;
};

const excluirPuil = id => emit("del", id);
const allcolumns = computed(()=>[
  {
    name: "pje",
    label: "Código",
    field: "numero"
  },
  {
    name: "puil",
    label: "Questão",
    field: "questao",
    style: () => `overflow: hidden;text-overflow: ellipsis; max-width: 40vw; white-space: pre-wrap;`
  },
  {
    name: "situacao",
    label: "Situação",
    field: "idSituacaoPuil",
    format: id => `${nomeSituacaoFromId(id)}`
  },
  { name: "questao", label: "Questão", field: "questao" },
  userStore.admin? { name: "acoes", label: "Ações", field: "acoes" } : {}
]);

const columns = computed(() =>
  allcolumns.value.filter(c => props.headers.includes(c.name))
);
</script>
